import { render, staticRenderFns } from "./create-investor-right-pane.vue?vue&type=template&id=47fa5f71&"
import script from "./create-investor-right-pane.vue?vue&type=script&lang=js&"
export * from "./create-investor-right-pane.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports